import { FC } from 'react';
import { translate } from '../../i18n';
import { togglePaymentCardsButtonStyles } from './styles';

export interface TogglePaymentCardsButtonProps {
  mode: 'add' | 'remove';
  onPress?: () => void;
  testID?: string;
}

/**
 * TogglePaymentCardsButton — Alterna entre pagar con 1 o 2 tarjetas.
 *
 * ✅ Estilos centralizados en styles.ts
 * ✅ i18n para ambos textos
 * ✅ Cero Tailwind, cero hardcodes
 */
export const TogglePaymentCardsButton: FC<TogglePaymentCardsButtonProps> = ({
  mode,
  onPress,
  testID = 'toggle-payment-cards-button',
}) => (
  <button
    type="button"
    onClick={onPress}
    data-testid={testID}
    style={togglePaymentCardsButtonStyles.button}
  >
    {mode === 'add'
      ? translate('paymentsUI.splitPayment.addSecondCard')
      : translate('paymentsUI.splitPayment.removeSecondCard')}
  </button>
);
